import moment from 'moment';

export function digitsFormatter(_: any, typing: any) {
  return typing.input?.toString().replace(/[^+\d]/g, '');
}

export function isValidDate(currentDate: moment.Moment, startDate: string, endDate: string) {
  return (
    moment(currentDate).startOf('day') < moment(startDate).startOf('day') || currentDate.startOf('day') > moment(endDate).startOf('day')
  );
}
